<template lang="html">
  <div class="ui-date-item">
    <!-- <div class="ui-date-item-head">{{dateFormat.m}}月<span>{{dateFormat.y}}年</span></div> -->
    <ul class="ui-date-weeks">
      <li class="ui-date-week" v-for="item in weeks">{{ item }}</li>
    </ul>
    <div class="ui-date-day-wrapper">
      <div class="ui-date-item-days" v-for="(day, i) in days" :key="i">
        <!-- <div class="ui-date-item-month" v-if="item.date !== ''">{{item.month}}</div> -->
        <div
          class="ui-date-item-day"
          v-for="item in day"
          :class="{
            hover:
              current.time === item.time &&
              !item.isFull &&
              !item.disabled &&
              canClick,
            disabled: item.disabled
          }"
          @click="doSomething(item)"
        >
          <span v-if="today === item.time" class="today">
            <i v-if="item.isFull" class="full">满</i>
            <i v-else>{{ item.date }}</i>
          </span>
          <span v-else>
            <i v-if="item.isFull" class="full">满</i>
            <i v-else>{{ item.date }}</i>
          </span>
          <!-- <div class="full" v-show="item.isFull">满</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    index: Number,
    current: Object,
    // 标志，true：可用时间，false：不可用时间，
    isAvailable: {
      type: Boolean,
      default: true
    },
    // 排期
    schedule: {
      type: Array,
      default() {
        return []
      }
    },
    fullDays: {
      type: Array,
      default() {
        return []
      }
    },
    canClick: {
      type: Boolean,
      default: true
    },
    showSimple: {
      // 是否只显示本周和下一周
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      days: [],
      dateObj: '',
      dateFormat: {
        y: '',
        m: '',
        month: ''
      },
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      today: '',
      weekNo: 0
    }
  },
  watch: {
    schedule(value) {
      this.getDays()
    },
    isAvailable(val) {
      this.getDays()
    }
  },
  methods: {
    isShow(no, num) {
      let flag = false
      if (this.showSimple) {
        const week_no = this.getMonthWeek()
        if (week_no === no) {
          flag = true
        }
        if (week_no + 1 > num) {
          if (week_no - 1 === no) {
            flag = true
          }
        } else if (week_no + 1 === no) {
          flag = true
        }
      } else {
        flag = true
      }
      return flag
    },
    zerofill(number) {
      return number < 10 ? `0${number}` : number
    },
    formatTime(t) {
      const year = t.getFullYear()
      const month = t.getMonth() + 1
      const date = t.getDate()
      return {
        year,
        month,
        date
      }
    },
    setDate(dateYYMM) {
      const t = dateYYMM ? new Date(`${dateYYMM}-01`) : new Date()
      const currentDate = new Date()
      this.today = `${currentDate.getFullYear()}-${this.zerofill(
        currentDate.getMonth() + 1
      )}-${this.zerofill(currentDate.getDate())}`
      if (this.index === 0) {
        this.weekNo = this.getMonthWeek()
      }
      const month = this.formatTime(t).month
      t.setMonth(month + this.index, 0)
      this.dateObj = t
    },
    daysCount() {
      const t = this.dateObj
      return t.getDate()
    },
    firstWhichDay(dateYYMM) {
      const t = dateYYMM ? new Date(`${dateYYMM}-01`) : new Date()
      const month = this.formatTime(t).month
      t.setMonth(month + this.index - 1, 1)
      return t.getDay()
    },
    getYM() {
      const t = this.dateObj
      const y = t.getFullYear()
      const m = t.getMonth() + 1
      this.dateFormat.y = y
      this.dateFormat.m = m
    },
    fomatMonth() {
      const t = this.dateObj
      const year = t.getFullYear()
      const arr = [
        `${year}年  一月`,
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月'
      ]
      this.dateFormat.month = arr[this.dateFormat.m - 1]
    },
    getDays() {
      this.setDate(this.lookMonths[0])
      this.getYM()
      this.fomatMonth()
      const { y, m, month } = this.dateFormat
      const count = this.daysCount()
      const day = this.firstWhichDay(this.lookMonths[0])
      const newArr = []
      const arr = [...new Array(day + count)]
      let item = {}
      let arr_inner = []
      const flag = !this.isAvailable
      arr.forEach((v, i) => {
        if (i % 7 === 0) {
          arr_inner = []
        }
        if (i < day) {
          item = {
            month: '',
            date: '',
            time: '',
            disabled: flag,
            isFull: false
          }
        } else {
          const date = i - (day - 1)
          const time = `${y}-${this.zerofill(m)}-${this.zerofill(date)}`
          const disabled = flag
            ? this.schedule.some(value => value === time)
            : !this.schedule.some(value => value === time)
          const isFull = this.fullDays.some(value => value === time)
          item = {
            month: i === day ? month : '',
            date,
            time,
            disabled,
            isFull
          }
        }
        arr_inner.push(item)
        if (i % 7 === 6 || i === arr.length - 1) {
          newArr.push(arr_inner)
        }
      })
      this.days = newArr
    },
    doSomething(item) {
      if (!this.canClick) {
        return
      }
      const time = this.current.time
      this.$emit('input', {
        isFull: item.isFull,
        disabled: item.disabled,
        time: item.disabled ? time : item.time
      })
    },
    // 获取今天是这个月的第几周
    getMonthWeek(dateStr) {
      const date = dateStr ? new Date(dateStr) : new Date()
      const week = date.getDay()
      const day = date.getDate()
      return Math.ceil((day + 6 - week) / 7)
    }
  },
  created() {
    this.getDays()
  },
  computed: {
    ...mapState(['lookMonths'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';

.ui-date-item {
  // display: flex;
  // flex-wrap: wrap;
  // align-items: center;
  // padding-left: rem(25px);
  // padding-right: rem(25px);
  // padding-bottom: rem(25px);
  background-color: #fff;
  padding: rem(30px);
  padding-bottom: 0;
  .ui-date-item-head {
    height: rem(80px);
    line-height: rem(80px);
    background: #f4f4f4;
    font-size: rem(32px);
    padding: 0 rem(25px);

    span {
      font-size: rem(26px);
      color: #999;
      margin-left: rem(10px);
    }
  }
  .ui-date-weeks {
    display: flex;

    font-size: rem(28px);
    //padding-top: rem(30px);
    background: #f7f7f7;
    border-radius: 4px 4px 0 0;
    li {
      flex: 1;
      text-align: center;
      color: #999;
      line-height: rem(40px);
      font-size: rem(24px);
      &:first-child {
        color: #ff6ea2;
      }
      &:last-child {
        color: #ff6ea2;
      }
    }
  }
  .ui-date-day-wrapper {
    padding: rem(25px) 0;
  }

  .ui-date-item-days {
    display: flex;
    flex-wrap: wrap;
    // height: rem(100px);
    margin-bottom: rem(17px);
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }
    .ui-date-item-month {
      height: rem(50px);
      font-size: rem(24px);
      line-height: rem(50px);
      color: #ff397e;
      white-space: nowrap;
    }
    .ui-date-item-day {
      position: relative;
      width: rem(98px);
      // height: rem(100px);
      // font-size: rem(24px);
      // line-height: rem(50px);
      color: #121212;
      font-size: rem(32px);
      // border-radius: 50%;
      span {
        display: flex;
        width: rem(70px);
        height: rem(70px);
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        i {
          line-height: rem(44px);
        }
      }
      &.disabled {
        color: #999;
        background-color: #fff;

        > span {
          color: #ccc;
        }
      }
      .full {
        color: #999;
        font-size: rem(30px);
      }
      .today {
        font-size: rem(32px);
        color: #fff;

        background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
        border-radius: 100%;
        //line-height: rem(32px);
      }
      &.hover {
        position: relative;
        // color: #ff397e;
        color: #fff;
        &::before {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          width: rem(54px);
          height: rem(54px);
          margin-left: rem(-27px);
          margin-top: rem(-25px);
          border-radius: 100%;
          background-color: #ff387e;
        }
        > span {
          position: relative;
          z-index: 1;
          color: #fff;
        }
      }
    }
    // &:nth-child(7n + 1), &:nth-child(7n) {
    //     .ui-date-item-day {
    //         // color: #999;
    //         &.hover {
    //             // color: #fff;
    //         }
    //         &.disabled {
    //             color: #999;
    //
    //             >span{
    //                 color: #999;
    //             }
    //         }
    //     }
    // }
  }
}
</style>
